import { serviceConsumer } from "../../network/ServiceConsumer";

const BASE = process.env.REACT_APP_BASE_URL;

// Thin wrappers over the Oireachtas M2/M3 backend (see spec repo,
// registration-and-payment.md). All teacher-gated calls send the login
// accesstoken via serviceConsumer.
// Each wrapper unwraps the endpoint's ONE response shape here so components
// never guess (an error payload must fail loudly, not render as the entity).
export const getOireachtasEvent = async (id) =>
  (await serviceConsumer("GET", `${BASE}/oireachtas/${id}`)).event;
export const getCompetitions = async (id) =>
  (await serviceConsumer("GET", `${BASE}/oireachtas/${id}/competitions`)).competitions;
export const getReference = () => serviceConsumer("GET", `${BASE}/oireachtas/reference`);
export const getRoster = async (id, includeHidden) =>
  (await serviceConsumer("GET", `${BASE}/oireachtas/${id}/roster${includeHidden ? "?includeHidden=true" : ""}`)).roster;
export const setRosterFlag = (dancer_id, hidden) =>
  serviceConsumer("POST", `${BASE}/oireachtas/roster/flag`, { dancer_id, hidden });
export const getTeams = async (id) =>
  (await serviceConsumer("GET", `${BASE}/oireachtas/${id}/teams`)).teams;
// The school's bill regrouped per family — what the teacher collects from whom.
export const getStatement = async (id) =>
  (await serviceConsumer("GET", `${BASE}/oireachtas/${id}/statement`)).statement;
// One FROZEN receipt per settled payment, oldest kept verbatim.
export const getReceipts = async (id) =>
  (await serviceConsumer("GET", `${BASE}/oireachtas/${id}/receipts`)).receipts;
// Add-ons the school has paid for (céilí tickets, ads …): [{ key, label, qty, amountCents }].
export const getAddOns = async (id) =>
  (await serviceConsumer("GET", `${BASE}/oireachtas/${id}/add-ons`)).addOns || [];
export const getCart = async (id) =>
  (await serviceConsumer("GET", `${BASE}/oireachtas/${id}/cart`)).result;
export const saveCart = async (id, items, teams, reclaimAllocations) =>
  (await serviceConsumer("POST", `${BASE}/oireachtas/${id}/cart`, {
    items, teams: teams || [], reclaimAllocations: reclaimAllocations || [],
  })).result;
export const quoteCart = (id, items, teams, reclaimAllocations) =>
  serviceConsumer("POST", `${BASE}/oireachtas/${id}/quote`,
    items || teams || reclaimAllocations
      ? { items: items || [], teams: teams || [], reclaimAllocations: reclaimAllocations || [] }
      : {});
// `plan` = { plan: "instalments", firstPaymentCents } to pay in instalments
// (card 15862648); omitted = pay in full.
export const oireachtasCheckout = (event_id, cart_id, plan) =>
  serviceConsumer("POST", `${BASE}/oireachtas/checkout`, { event_id, cart_id, ...(plan || {}) });
// The school's instalment orders on this event: total, paid, balance, due date.
export const getBalance = async (id) =>
  (await serviceConsumer("GET", `${BASE}/oireachtas/${id}/balance`)).orders || [];
// Start one balance payment; returns { checkout: { client_secret }, amountCents, balanceAfterCents }.
export const payBalance = (id, order_id, amountCents) =>
  serviceConsumer("POST", `${BASE}/oireachtas/${id}/balance/pay`, { order_id, amountCents });
